module.exports = __webpack_public_path__ + "img/hundred_points.787d1581.gif";